import Vue from 'vue'
import './registerServiceWorker'

import App from './App.vue'
import router from './router'

import { firestorePlugin } from 'vuefire'

Vue.use(firestorePlugin)

// import VueFire from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'
// Vue.use(VueFire)
firebase.initializeApp({
	projectId: 'gameslib-c760f',
	databaseURL: 'https://gameslib-c760f.firebaseio.com'
})

export const db = firebase.firestore()
db.enablePersistence({synchronizeTabs: true})
	.catch(function(err) {
		console.log(err.code);
	})

Vue.config.productionTip = false

new Vue({
	router,
	render: function (h) { return h(App) }
}).$mount('#app')
